<div *ngIf="capas" class="wrapper-banner-img">
    <img id="capa_desktop" src="{{capas?.desktopUrl}}" alt="First slide">
    <img id="capa_mobile" src="{{capas?.mobileUrl}}" alt="First slide">
</div>
<div *ngIf="!capas && loading" class="placehoder-banners">

